import { currencyFormat, formatCifra } from "../repositories/utils";
import { getAdminProductItem } from "../repositories/dataRetrieve";
import { useNavigate, useLocation } from 'react-router-dom';
import { Replay } from "@mui/icons-material";
import { useEffect, useState } from 'react';
import { CircularProgress,
        Typography,
        Button,
        Paper,
        Grid,
        Chip,
        Box } from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import Image from "../static/ImagesProvider";

const CommonProductDetailPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { productId } = location.state || {};
    const [fecAdquisicion, setFecAdquisicion] = useState('');
    const [productItem, setProductItem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [index, setIndex] = useState(0);

    const handleChange = (cur, prev) => {
        setIndex(cur);
    };

    useEffect(() => {
        const getProduct = async () => {
            setIsLoading(true);
            const resp = await getAdminProductItem(productId);

            if (resp?.message?.toUpperCase() === "OK") {
                setFecAdquisicion(resp?.data[0].fecha_adquisicion.toDate().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }));
                setProductItem(resp?.data);
                setIsLoading(false);
            } else {
                setProductItem(null);
                setIsLoading(false);
            };
        };

        getProduct();
    }, []);

    return (
        <Box
            sx={{
                backgroundColor: 'rgba(255, 255, 255, 1)',
                margin: 'auto',
                marginTop: {xs: '2vh', md:'5vh'},
                marginBottom: {xs: '2vh', md:'5vh'},
                height: {xs: '85vh', md:'80vh'},
                width: '90vw',
                borderRadius: '20px',
                overflowY: 'auto'
            }}
        >
            {isLoading ?
                <Typography
                    variant="h2"
                    component="div"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        color: 'dimgray',
                        fontFamily: 'Barlow',
                        height: '70vh',
                        placeItems: 'center'
                    }}
                >
                    <CircularProgress sx={{ width: "70px !important", height: "70px !important", color: "#62C21B" }} />
                </Typography>
            :
                <>
                    {productItem ?
                        <Box
                            sx={{
                                width: {xs: '90%', md: '96%'},
                                margin: {xs: '5%', md: '2%'}
                            }}
                        >
                            <Box sx={{ flexGrow: 1, padding: 4 }}>
                                <Grid container spacing={4} alignItems="center">
                                    <Grid item xs={12} md={5}>
                                        {productItem[0].images.length === 0 ?
                                            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                                <Box
                                                    component="img"
                                                    sx={{
                                                        width: '100%',
                                                        objectFit: 'cover',
                                                        display: 'block'
                                                    }}
                                                    src={Image.NoImage}
                                                />
                                            </Paper>
                                        :
                                            <Carousel
                                                index={index}
                                                onChange={handleChange}
                                                autoPlay={true}
                                                animation="slide"
                                                indicators={false}
                                                navButtonsAlwaysVisible={false}
                                                sx={{ textAlign: '-webkit-center' }}
                                            >
                                                {productItem[0].images.map((item, i) => (
                                                    <>
                                                        {item.type === "image/jpeg" ?
                                                            <Paper key={i} elevation={0} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                                                <Box
                                                                    component="img"
                                                                    sx={{
                                                                        width: { xs: '100%', md: 'auto' },
                                                                        height: { xs: 'auto', md: 300 },
                                                                        display: 'block'
                                                                    }}
                                                                    src={item.url}
                                                                />
                                                            </Paper>
                                                        :
                                                            <video style={{ width: { xs: '100%', md: 'auto' }, height: "300px" }} controls>
                                                                <source src={item.url} type="video/mp4" />
                                                            </video>
                                                        }
                                                    </>
                                                ))}
                                            </Carousel>
                                        }
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                gap: 2,
                                                mt: 2,
                                                justifyContent: 'center',
                                                overflowX: 'auto',
                                                py: 1
                                            }}
                                        >
                                            {productItem[0].images.map((item, i) => (
                                                <Box
                                                    key={i}
                                                    onClick={() => setIndex(i)}
                                                    sx={{
                                                        width: 80,
                                                        height: 60,
                                                        cursor: 'pointer',
                                                        borderRadius: 2,
                                                        overflow: 'hidden',
                                                        border: i === index ? '3px solid #1976d2' : '2px solid transparent',
                                                        opacity: i === index ? 1 : 0.6,
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': { opacity: 1 }
                                                    }}
                                                >
                                                    <Box
                                                        component="img"
                                                        src={item.url}
                                                        alt={`thumb-${i}`}
                                                        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    />
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={7}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            <Typography gutterBottom variant="h4" component="div" sx={{ textAlign: "end", margin: "5px" }}>
                                                {productItem[0].estatus === 'en_venta' ?
                                                    <Chip sx={{ color: 'white', fontWeight: 500 }} color="warning" label="En venta" />
                                                :
                                                    <>
                                                        {productItem[0].estatus === 'registrado' ?
                                                            <Chip sx={{ color: 'white', fontWeight: 500 }} color="success" label="Registrado" />
                                                        :
                                                            <Chip sx={{ color: 'white', fontWeight: 500 }} color="error" label="Vendido" />
                                                        }
                                                    </>
                                                }
                                            </Typography>
                                            <Typography variant="h3" component="h1" fontWeight="bold">
                                                {productItem[0].marca} - {productItem[0].descripcion_corta}
                                            </Typography>

                                            <Typography variant="body1" color="text.secondary" paragraph>
                                                {productItem[0].descripcion_larga}
                                            </Typography>

                                            <Typography variant="body1" color="text.secondary" paragraph>
                                                <b>Módelo:</b> {productItem[0].modelo}<br />
                                                <b>Número de serie:</b> {productItem[0].n_serie || 'S/N'}<br />
                                                <b>Fecha de adquisición:</b> {fecAdquisicion}<br />
                                                <b>Costo de adquisición:</b> {currencyFormat.format(parseFloat(productItem[0].costo_adquisicion))}<br />
                                                <b>Piezas en existencia:</b> {formatCifra(productItem[0].piezas) || 0}<br />
                                                <b>Piezas vendidas:</b> {formatCifra(productItem[0].vendidos) || 0}<br />
                                                <b>Precio de venta:</b> {currencyFormat.format(parseFloat(productItem[0].precio_venta))}<br />
                                            </Typography>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignSelf: { xs: 'center', md: 'end' },
                                                    gap: 2
                                                }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    size="large"
                                                    color="error"
                                                    onClick={() => navigate(-1)}
                                                    startIcon={<Replay />}
                                                >
                                                    Regresar
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    :
                        <Typography
                            variant="h2"
                            component="div"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                color: 'dimgray',
                                fontFamily: 'Barlow',
                                height: '70vh',
                                placeItems: 'center'
                            }}
                        >
                            Producto sin información
                        </Typography>
                    }
                </>
            }
        </Box>
    )
}

export default CommonProductDetailPage;
